<template>
  <div class="relative w-full flex justify-between gap-y-4 border border-[#DFE2E5] bg-white rounded-[10px] px-4 py-3 shadow-[0_1px_4px_rgba(0,0,0,0.07)]">
    <div
      v-if="!readonly"
      class="move cursor-move mr-[9px] mt-[2px]"
      aria-label="Drag handle"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="w-4 h-4"
      ><circle
        cx="9"
        cy="12"
        r="1"
      /><circle
        cx="9"
        cy="5"
        r="1"
      /><circle
        cx="9"
        cy="19"
        r="1"
      /><circle
        cx="15"
        cy="12"
        r="1"
      /><circle
        cx="15"
        cy="5"
        r="1"
      /><circle
        cx="15"
        cy="19"
        r="1"
      /></svg>
    </div>
    <b-checkbox
      v-if="!readonly"
      v-model="checked"
      class="mr-[9px] mt-[-1px] !rounded-[4px] no-drag"
      @click.stop
      @change="$emit('on-select', {hash: variable.hash, checked: checked})"
    />

    <div class="cursor-default flex flex-col gap-y-2 w-full">
      <p class="text-sm text-[#6E747A] font-medium mb-0">
        Name
      </p>

      <p class="text-base text-[#414141] mb-0">
        {{ variable.name }}
      </p>
    </div>

    <div class="cursor-default flex flex-col gap-y-2 w-full">
      <p class="text-sm text-[#6E747A] font-medium mb-0">
        Key
      </p>

      <p class="text-base text-[#414141] mb-0">
        {{ variable.key }}
      </p>
    </div>

    <div class="cursor-default flex flex-col gap-y-2 w-full">
      <p class="text-sm text-[#6E747A] font-medium mb-0">
        Type
      </p>

      <p class="text-base text-[#414141] mb-0 capitalize">
        {{ variable.type }}
      </p>
    </div>

    <div
      v-if="!readonly"
      class="absolute top-[23px] right-[10px] no-drag"
      @mousedown.stop
    >
      <b-dropdown
        variant="new-project-card-dropdown"
        right
        dropup
        toggle-class="text-decoration-none !bg-[#fff] no-drag"
        menu-class="project-menu py-0"
        no-caret
      >
        <template #button-content>
          <svg
            width="24"
            height="5"
            viewBox="0 0 24 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="2.5"
              cy="2.5"
              r="2.5"
              fill="#4F83E3"
            />
            <circle
              cx="12.0714"
              cy="2.5"
              r="2.5"
              fill="#4F83E3"
            />
            <circle
              cx="21.3572"
              cy="2.5"
              r="2.5"
              fill="#4F83E3"
            />
          </svg>
        </template>

        <b-dropdown-item
          class="d-flex align-items-center"
          link-class="dashboard-menu-link !flex items-center text-[15px]"
          @click.stop="editVariable"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4 mr-2"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.8049 1.52858C11.5446 1.26823 11.1224 1.26823 10.8621 1.52858L1.52876 10.8619C1.40373 10.9869 1.3335 11.1565 1.3335 11.3333V14C1.3335 14.3682 1.63197 14.6666 2.00016 14.6666H4.66683C4.84364 14.6666 5.01321 14.5964 5.13823 14.4714L14.4716 5.13805C14.7319 4.8777 14.7319 4.45559 14.4716 4.19524L11.8049 1.52858ZM12.0002 5.72384L10.2763 3.99998L11.3335 2.94279L13.0574 4.66665L12.0002 5.72384ZM9.3335 4.94279L11.0574 6.66665L5.3335 12.3905L3.60964 10.6666L9.3335 4.94279ZM2.66683 11.6095L4.39069 13.3333H2.66683V11.6095Z"
              fill="currentColor"
            />
            <path
              d="M8.66683 13.3333C8.29864 13.3333 8.00016 13.6318 8.00016 14C8.00016 14.3682 8.29864 14.6666 8.66683 14.6666H14.0002C14.3684 14.6666 14.6668 14.3682 14.6668 14C14.6668 13.6318 14.3684 13.3333 14.0002 13.3333H8.66683Z"
              fill="currentColor"
            />
          </svg>

          Edit Variables
        </b-dropdown-item>

        <b-dropdown-item
          class="d-flex align-items-center"
          link-class="dashboard-menu-link !flex items-center text-[15px]"
          @click.stop="moveToFolder"
        >
          <svg
            width="18"
            height="14"
            viewBox="0 0 18 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4 mr-2"
          >
            <g clip-path="url(#clip0_15191_86790)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.583496 2.91667C0.583496 1.95017 1.367 1.16667 2.3335 1.16667H5.8335C6.02854 1.16667 6.21067 1.26415 6.31886 1.42643L7.31235 2.91667H11.6668C12.6333 2.91667 13.4168 3.70017 13.4168 4.66667V11.0833C13.4168 12.0498 12.6333 12.8333 11.6668 12.8333H2.3335C1.367 12.8333 0.583496 12.0498 0.583496 11.0833V2.91667ZM2.3335 2.33334C2.01133 2.33334 1.75016 2.59451 1.75016 2.91667V11.0833C1.75016 11.4055 2.01133 11.6667 2.3335 11.6667H11.6668C11.989 11.6667 12.2502 11.4055 12.2502 11.0833V4.66667C12.2502 4.34451 11.989 4.08334 11.6668 4.08334H7.00016C6.80512 4.08334 6.62299 3.98586 6.5148 3.82358L5.52131 2.33334H2.3335Z"
                fill="currentColor"
              />
              <rect
                x="9.625"
                y="4.11252"
                width="7.875"
                height="7.525"
                fill="white"
              />
            </g>
            <g clip-path="url(#clip1_15191_86790)">
              <path
                d="M13.566 10.0662C13.3667 10.2655 13.3667 10.5887 13.566 10.788C13.7653 10.9873 14.0885 10.9873 14.2878 10.788L16.8399 8.23592C17.0393 8.03659 17.0393 7.71341 16.8399 7.51408L14.2878 4.962C14.0885 4.76267 13.7653 4.76267 13.566 4.962C13.3667 5.16133 13.3667 5.48451 13.566 5.68384L15.2467 7.36458H6.27067C5.98878 7.36458 5.76025 7.59311 5.76025 7.875C5.76025 8.1569 5.98878 8.38542 6.27067 8.38542H15.2467L13.566 10.0662Z"
                fill="currentColor"
              />
            </g>
            <defs>
              <clipPath id="clip0_15191_86790">
                <rect
                  width="14"
                  height="14"
                  fill="white"
                />
              </clipPath>
              <clipPath id="clip1_15191_86790">
                <rect
                  width="12.25"
                  height="12.25"
                  fill="white"
                  transform="translate(5.25 1.75)"
                />
              </clipPath>
            </defs>
          </svg>

          Move to Folder
        </b-dropdown-item>

        <b-dropdown-item
          class="d-flex align-items-center"
          link-class="dashboard-menu-link !flex items-center text-[15px]"
          @click.stop="copyShareCode"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4 mr-2"
          >
            <path
              d="M14 6.00001L14 2.00001M14 2.00001H9.99999M14 2.00001L8 8M6.66667 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2V10.8C2 11.9201 2 12.4802 2.21799 12.908C2.40973 13.2843 2.71569 13.5903 3.09202 13.782C3.51984 14 4.07989 14 5.2 14H10.8C11.9201 14 12.4802 14 12.908 13.782C13.2843 13.5903 13.5903 13.2843 13.782 12.908C14 12.4802 14 11.9201 14 10.8V9.33333"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          Share Variable
        </b-dropdown-item>

        <delete-confirm
          title="Are you sure?"
          description="Global variable will be deleted permanently."
          @confirm="deleteVariable"
        >
          <template #activator="{on}">
            <b-dropdown-item
              class="d-flex align-items-center"
              link-class="dashboard-menu-link !flex items-center text-[15px]"
              v-on="on"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="w-4 h-4 mr-2"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.5 0.75C7.08579 0.75 6.75 1.08579 6.75 1.5V3H3C2.58579 3 2.25 3.33579 2.25 3.75C2.25 4.16421 2.58579 4.5 3 4.5H15C15.4142 4.5 15.75 4.16421 15.75 3.75C15.75 3.33579 15.4142 3 15 3H11.25V1.5C11.25 1.08579 10.9142 0.75 10.5 0.75H7.5ZM9.75 3H8.25V2.25H9.75V3Z"
                  fill="currentColor"
                />
                <path
                  d="M7.5 8.25C7.91421 8.25 8.25 8.58579 8.25 9V13.5C8.25 13.9142 7.91421 14.25 7.5 14.25C7.08579 14.25 6.75 13.9142 6.75 13.5V9C6.75 8.58579 7.08579 8.25 7.5 8.25Z"
                  fill="currentColor"
                />
                <path
                  d="M11.25 9C11.25 8.58579 10.9142 8.25 10.5 8.25C10.0858 8.25 9.75 8.58579 9.75 9V13.5C9.75 13.9142 10.0858 14.25 10.5 14.25C10.9142 14.25 11.25 13.9142 11.25 13.5V9Z"
                  fill="currentColor"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3.00001 5.25C2.78259 5.25 2.57587 5.34435 2.43341 5.5086C2.29096 5.67285 2.2268 5.89083 2.25754 6.10607L3.57356 15.3182C3.73191 16.4267 4.68123 17.25 5.80095 17.25H12.1991C13.3188 17.25 14.2681 16.4267 14.4264 15.3182L15.7425 6.10607C15.7732 5.89083 15.709 5.67285 15.5666 5.5086C15.4241 5.34435 15.2174 5.25 15 5.25H3.00001ZM5.05849 15.1061L3.86476 6.75H14.1352L12.9415 15.1061C12.8887 15.4756 12.5723 15.75 12.1991 15.75H5.80095C5.42771 15.75 5.11127 15.4756 5.05849 15.1061Z"
                  fill="currentColor"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.5 0.75C7.08579 0.75 6.75 1.08579 6.75 1.5V3H3C2.58579 3 2.25 3.33579 2.25 3.75C2.25 4.16421 2.58579 4.5 3 4.5H15C15.4142 4.5 15.75 4.16421 15.75 3.75C15.75 3.33579 15.4142 3 15 3H11.25V1.5C11.25 1.08579 10.9142 0.75 10.5 0.75H7.5ZM9.75 3H8.25V2.25H9.75V3Z"
                  stroke="white"
                  stroke-width="0.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.5 8.25C7.91421 8.25 8.25 8.58579 8.25 9V13.5C8.25 13.9142 7.91421 14.25 7.5 14.25C7.08579 14.25 6.75 13.9142 6.75 13.5V9C6.75 8.58579 7.08579 8.25 7.5 8.25Z"
                  stroke="white"
                  stroke-width="0.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.25 9C11.25 8.58579 10.9142 8.25 10.5 8.25C10.0858 8.25 9.75 8.58579 9.75 9V13.5C9.75 13.9142 10.0858 14.25 10.5 14.25C10.9142 14.25 11.25 13.9142 11.25 13.5V9Z"
                  stroke="white"
                  stroke-width="0.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3.00001 5.25C2.78259 5.25 2.57587 5.34435 2.43341 5.5086C2.29096 5.67285 2.2268 5.89083 2.25754 6.10607L3.57356 15.3182C3.73191 16.4267 4.68123 17.25 5.80095 17.25H12.1991C13.3188 17.25 14.2681 16.4267 14.4264 15.3182L15.7425 6.10607C15.7732 5.89083 15.709 5.67285 15.5666 5.5086C15.4241 5.34435 15.2174 5.25 15 5.25H3.00001ZM5.05849 15.1061L3.86476 6.75H14.1352L12.9415 15.1061C12.8887 15.4756 12.5723 15.75 12.1991 15.75H5.80095C5.42771 15.75 5.11127 15.4756 5.05849 15.1061Z"
                  stroke="white"
                  stroke-width="0.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              Delete Variable
            </b-dropdown-item>
          </template>
        </delete-confirm>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
import DeleteConfirm from '@/components/editor/modals/DeleteConfirm.vue'

export default {
  name: 'GlobalVariableItem',
  components: {DeleteConfirm},
  props: {
    variable: {
      type: Object,
      required: false
    },
    selectAll: {
      type: Boolean,
      required: false
    },
    readonly: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      checked: false
    }
  },
  methods: {
    editVariable () {
      this.$emit('edit', this.variable)
    },
    deleteVariable () {
      this.$emit('delete', this.variable)
    },
    moveToFolder () {
      this.$emit('move-to-folder', this.variable)
    },
    copyShareCode () {
      this.$copyText(this.variable.hash)
      this.$swal({
        icon: 'success',
        title: 'Copied!',
        toast: true,
        position: 'top-right',
        showConfirmButton: false,
        timer: 1500
      })
    }
  },
  watch: {
    selectAll (val) {
      setTimeout(() => {
        this.checked = val
        this.$emit('on-select', {hash: this.variable.hash, checked: this.checked})
      }, 100)
    }
  }
}
</script>

<style>
.dropdown.show .btn:not(.no-focus) {
  border-color: transparent;
}
</style>
